import React from 'react';
import PeriodicTable from './Components/PeriodicTable';

const App = () => {
  return (
    <div className="App">
      <h1>Periodic Table</h1>
      <PeriodicTable />
    </div>
  );
};

export default App;
